import React, { useState } from 'react';
import { ISummaryPageSettings } from '../../../models/summary/ISummaryPageSettings';
import styles from './summary-degree-old.module.scss';
import { ISummaryData } from '../../../models/summary/ISummaryData';
import { ButtonStyleType } from '../../../constants/button-style-type';
import Button from '../../atoms/button/button';
import TagManager from 'react-gtm-module';
import { CourseType } from '../../../constants/course-type';
import { ISummaryCourse } from '../../../models/summary/ISummaryCourse';
import Link from 'next/link';
import { ApplicationType } from '../../../constants/application-type';
import ModalBox from '../modal-box/modal-box';
import IButton from '../../../models/button/IButton';
import colorStyle from '../../../styles/utils/variables.module.scss';
import { removeSpacefromText } from '../../../../src/utils/string-helpers/formatting.helper';

type Props = {
  degree: ISummaryData;
  summaryPageSettings: ISummaryPageSettings;
  brandName: string;
  googleTagId?: string;
  courseList?: ISummaryCourse[];
  application: string;
};
export default function SummaryDegreeOld({
  degree,
  summaryPageSettings,
  brandName,
  googleTagId,
  courseList,
  application,
}: Props) {
  // for redirect modal
  const [showModal, setShowModal] = useState(false);

  let applyURL = null;
  const pushDataLayer = () => {
    if (googleTagId) {
      TagManager.dataLayer({
        dataLayer: { brandName: brandName, courseName: degree.name, event: 'applyButtonClick' },
      });
    }

    // for redirect modal
    if (application == ApplicationType.UniBrandedB2c) {
      setShowModal(true);
    }
  };
  if (summaryPageSettings.b2cFlag) {
    applyURL = summaryPageSettings.applyURL + `/` + degree.brandId + `/` + degree.id;
  } else {
    if (degree.applicationMethods.includes(removeSpacefromText(CourseType.DirectEntryWaiver,'all'))) {
      applyURL = summaryPageSettings.dewApplyURL;
    } else {
      applyURL = summaryPageSettings.applyURL;
    }
  }
  const courseSlug = courseList?.filter((c) => c.programId === degree?.id)[0]?.programSlug;

  const buttonProps = {
    buttonStyle: ButtonStyleType.Filled,
    buttonSize: summaryPageSettings.buttonSize,
    copyColor: summaryPageSettings.buttonCopyColor,
    backgroundColor: summaryPageSettings.backgroundColor,
    hoverBackgroundColor: summaryPageSettings.hoverBackgroundColor,
    activeBackgroundColor: summaryPageSettings.activeBackgroundColor,
    buttonAriaLabel: `Apply to ${degree?.name}`,
    heapIdentifier: 'degree-apply-cta',
    children: 'Apply',
    buttonID: 'degree-apply-cta',
    onClick: pushDataLayer,
  };

  const modalFooterButton: IButton = {
    ...buttonProps,
    buttonURL: applyURL,
    buttonRole: 'link',
    buttonID: 'degree-modalbox-apply-cta',
    buttonName: 'degree-modalbox-apply-cta',
    onClick: () => setShowModal(false),
    children: summaryPageSettings?.redirectModal?.buttonText,
  };

  return (
    <>
      {application == ApplicationType.UniBrandedB2c && (
        <ModalBox
          isOpen={showModal}
          title={summaryPageSettings?.redirectModal?.title}
          onClose={() => setShowModal(false)}
          footerButton={modalFooterButton}
          autoClickAfterDelay
          modalSize='lg'
          modalVerticallyCenter
        >
          {summaryPageSettings?.redirectModal?.message}
        </ModalBox>
      )}
      <div className={`${styles[`summary-degree`]} row`}>
        <div className='col'>
          <div className={`${styles[`degree-row`]} pb-4`}>
            {courseSlug ? (
              <h4 className={`${styles[`degree-name`]} mb-4 mt-4`}>
                <Link href={summaryPageSettings.brandURL + '/courses/' + courseSlug}>
                  {degree.name}
                </Link>
              </h4>
            ) : (
              <h4 className={`${styles[`degree-name`]} mb-4 mt-4`}>{degree.name}</h4>
            )}
            <div
              className={`align-items-md-baseline d-flex justify-content-md-between w-100 ${
                styles[`degree-footer`]
              }`}
            >
              {application == ApplicationType.UniBrandedB2c ? (
                <Button {...buttonProps} />
              ) : (
                <Button
                  {...buttonProps}
                  buttonNewTab='_blank'
                  buttonURL={applyURL}
                  buttonRole='link'
                >
                  Apply
                </Button>
              )}

              {!!degree.cricosCodes && (
                <h5 className={`${styles[`sub-header`]} mb-md-0 mb-3`}>
                  <span>CRICOS Code:</span> {degree.cricosCodes}
                </h5>
              )}
            </div>
            {!!degree.applicationMethods.includes(CourseType.DirectEntryWaiver) && (
              <h6 className={`${styles[`sub-header`]} ${styles[`font-size-small`]} mt-3 mb-0`}>
                Direct Entry Waiver
              </h6>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
